import type { InjectionKey, Ref } from 'vue';

/** Флаг: на время экспорта таблицы в PDF виртуализация строк отключена (полный DOM). */
export type TAggregatedTablePdfExportVirtualization = Ref<boolean>;

export const AGGREGATED_TABLE_PDF_EXPORT_VIRTUALIZATION_KEY: InjectionKey<TAggregatedTablePdfExportVirtualization> =
  Symbol('aggregatedTablePdfExportVirtualization');
